import { IPostDonationRequest } from "@/repositories/donatie.repository";

export const DonationService = {
  Post: (params: IPostDonationRequest) => DonationRepository.Post(params),
}